// Importing constants
import closeImgIcon from 'static/images/close.svg';
import LeftArrow from 'static/images/left-arrow.png';

// Importing components
import {
    Description,
    Accordion,
    ChargebackComponents,
    ConditionalComponent,
    Modal,
    AlertModal,
} from 'components';

import { Button } from 'components/form-elements';
import {
    CHARGEBACK_STATUS_ENUM,
    POPUP_ENUM,
    POPUP_TITLE_ENUM,
    CHARGEBACK_UPDATE_TERMINAL_STATE,
} from '../../utils/constants/commonValues';
import { ChargeBackModalComponents } from '../../components/ChargebackComponents/ChargeBackModalComponents';

// constants
import { META_INFO_ENUM, TRANSACTION_INFO_ENUM } from './constant';

// actions
import {
    fetchChargeBackDetailsRequest,
    chargeBackAgentActionRequest,
    chargeBackMerchantActionRequest,
} from './redux/chargeback.actions';

// Importing libs
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams, useHistory } from 'react-router-dom';

// styles
import './chargebackDetails.scss';
import moment from 'moment';

const ChargeBackStatusView = ({ status, chargeabckLevel }) => {
    return (
        <div className={`button-container-child status ${status}`}>
            {CHARGEBACK_STATUS_ENUM[status]?.label} {chargeabckLevel ? `- ${chargeabckLevel}` : ''}
        </div>
    );
};

ChargeBackStatusView.propTypes = {
    status: PropTypes.string,
    chargeabckLevel: PropTypes.string
};

const ChargebackDetails = ({ chargebackReduxData, actions, auth }) => {
    const { chargebackId, orderId } = useParams();
    const history = useHistory();

    const {
        charegebackDetailsData,
        chargebackMerchantAction,
        chargebackAgentAction,
    } = chargebackReduxData;

    const {
        transactionData,
        chargebackData,
        chargebackMetaData,
    } = charegebackDetailsData;


    const [popUpComponent, setPopUpComponent] = useState('');
    const [selectedSubChargeback, setSelectedChargeaback] = useState({});
    const [fullyAccpetConfirm, setFullyAccpetConfirm] = useState(false);

    const resetDetailsPage = () => {
        actions.fetchChargeBackDetailsRequest({ orderId, chargebackId , type:'CHARGEBACK'});
        setFullyAccpetConfirm(false);
        setSelectedChargeaback({});
        setPopUpComponent('');
    };

    useEffect(() => {
        if (chargebackId && orderId) {
            resetDetailsPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargebackId, orderId]);

    useEffect(() => {
        if (chargebackMerchantAction?.isMerchantActionSuccess) {
            resetDetailsPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargebackMerchantAction]);

    useEffect(() => {
        if (chargebackAgentAction?.isChargebackAgentAction) {
            resetDetailsPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargebackAgentAction]);

    const handleUpdateStatusClick = () => {
        setPopUpComponent(POPUP_ENUM.UPDATE_FORM);
    };

    const handleChargebackReRaiseClicked = () => { };

    const handleChargebackFullyAccept = subChargebackDetails => {
        setFullyAccpetConfirm(true);
        setSelectedChargeaback(subChargebackDetails);
    };

    const handleChargebackDefend = subChargebackDetails => {
        setPopUpComponent(POPUP_ENUM.CHARGEBACK_DEFEND);
        setSelectedChargeaback(subChargebackDetails);
    };

    const onFullyAcceptConfirm = () => {
        const payload = {
            details: {
                cbId: chargebackMetaData.currentChargebackId,
                merchantAction: 'FULLY_ACCEPT',
                txnId: transactionData.txnRefNumber,
                entityCode: transactionData.merchantId,
                merchantRemarks: 'Accepting chargeback completely!',
            },
        };
        actions.chargeBackMerchantActionRequest(payload);
    };

    const handleChargebackExtensionClick = subChargebackDetails => {
        setPopUpComponent(POPUP_ENUM.EXTEND_DEADLINE_FORM);
        setSelectedChargeaback(subChargebackDetails);
    };

    const handleComponentSubmit = (component, values) => {
        
        if (component === POPUP_ENUM.UPDATE_FORM) {
            const payload = {
                details: {
                    agentAction: values?.status,
                    cbId: chargebackMetaData.currentChargebackId,
                    txnId: transactionData.txnRefNumber,
                    entityCode: transactionData.merchantId,
                },
                files: values?.files || [],
            };

            if (values.chargebackLevel) {
                payload.details.chargebackLevel = values.chargebackLevel;
            }

            if (values.remarks) {
                payload.details.remarks = values.remarks
            }

            actions.chargeBackAgentActionRequest(payload);
        } else if (component === POPUP_ENUM.EXTEND_DEADLINE_FORM) {
            const payload = {
                details: {
                    updateCbDueDate: moment(
                        selectedSubChargeback.customerAgentData.dueDate,
                        'YYYY-MM-DD HH:mm:ss'
                    )
                        .add(values?.deadline, 'days')
                        .format('YYYY-MM-DD HH:mm:ss'),
                    cbId: chargebackMetaData.currentChargebackId,
                    txnId: transactionData.txnRefNumber,
                    entityCode: transactionData.merchantId,
                },
                files: values?.files || [],
            };
            actions.chargeBackAgentActionRequest(payload);
        } else if (component === POPUP_ENUM.CHARGEBACK_DEFEND) {
            const payload = {
                details: {
                    cbId: chargebackMetaData.currentChargebackId,
                    merchantAction: 'CONTEST',
                    txnId: transactionData.txnRefNumber,
                    entityCode: transactionData.merchantId,
                    merchantRemarks: values?.remarks,
                },
                files: values?.files || [],
            };
            actions.chargeBackMerchantActionRequest(payload);
        }
    };

    // Generating meta description data
    const metaDescriptionData =
        transactionData &&
        META_INFO_ENUM.map(item => {
            return { ...item, children: transactionData[item.key] };
        });

    // Generating transaction description data
    const transactionDescriptionData =
        transactionData &&
        TRANSACTION_INFO_ENUM.map(item => {
            return { ...item, children: transactionData[item.key] };
        });

    return (
        <div className="chargeback-details-wrapper">
            <div className="chargeback-header">
                <div className="heading">
                    <img
                        src={LeftArrow}
                        alt="Back"
                        className="leftArrow"
                        onClick={() => {
                            history.goBack();
                        }}
                    />
                    Chargeback Details
                </div>
                <div className="button-container">
                    <ChargeBackStatusView
                        status={chargebackMetaData?.currentChargebackStatus}
                        chargeabckLevel={chargebackMetaData?.currentChargebackLevel}
                    />
                    <ConditionalComponent
                        isVisible={
                            auth?.userDetails?.userLevel === 'ADMIN' &&
                            !CHARGEBACK_UPDATE_TERMINAL_STATE.includes(
                                chargebackMetaData?.currentChargebackStatus
                            )
                        }
                    >
                        <div className="button-container-child">
                            <Button
                                buttonType="primary"
                                text="Update Info"
                                handleClick={handleUpdateStatusClick}
                            />
                        </div>
                    </ConditionalComponent>
                </div>
            </div>

            <div className="chargeback-details">
                <div className="meta-info-container">
                    <Description items={metaDescriptionData} />
                    {/* Rendering meta information */}
                </div>

                <Accordion
                    customClass="rounded-accordion"
                    isOpened={false}
                    isArrowIndicator
                    id="chargeback-details-accordion"
                    upperComponent={
                        <h3 className="page-tile sm">Transaction Details</h3>
                    }
                    lowerComponent={
                        <Description items={transactionDescriptionData} />
                    }
                />

                <div className="chargeback-level-list-container">
                    <ConditionalComponent
                        isVisible={chargebackData && chargebackData.length > 0}
                    >
                        {chargebackData?.map((item, index) => (
                            <ChargebackComponents.ChargeBackAccordion
                                chargebackDetails={item}
                                key={index}
                                currentChargebackId={
                                    chargebackMetaData.currentChargebackId
                                }
                                chargebackIndex={index}
                                handleChargebackReRaiseClicked={
                                    handleChargebackReRaiseClicked
                                }
                                handleChargebackExtensionClick={
                                    handleChargebackExtensionClick
                                }
                                handleChargebackFullyAccept={
                                    handleChargebackFullyAccept
                                }
                                handleChargebackDefend={handleChargebackDefend}
                                userDetails={auth?.userDetails}
                            />
                        ))}
                    </ConditionalComponent>
                </div>

                {/* <Accordion*/}
                {/*    customClass="rounded-accordion"*/}
                {/*    isOpened={true}*/}
                {/*    isArrowIndicator*/}
                {/*    id="chargeback-details-accordion"*/}
                {/*    upperComponent={*/}
                {/*        <h3 className="page-tile sm">Activity History</h3>*/}
                {/*    }*/}
                {/*    lowerComponent={*/}
                {/*        <TwoSideTimeline*/}
                {/*            data={timelineData}*/}
                {/*            customClassName="chargeback-timeline-container"*/}
                {/*        />*/}
                {/*    }*/}
                {/* />*/}

                <Modal
                    modalIsOpen={popUpComponent ? true : false}
                    closeModal={() => setPopUpComponent(null)}
                    customWrapperClass={`content-modal  ${popUpComponent === POPUP_ENUM.CHARGEBACK_DEFEND
                        ? 'modal-xl'
                        : ''
                        }`}
                >
                    <div className="modal-header">
                        <h2 className="modal-heading">
                            {POPUP_TITLE_ENUM[popUpComponent] || ''}
                        </h2>
                        <img
                            src={closeImgIcon}
                            alt="Close"
                            onClick={() => setPopUpComponent(null)}
                        />
                    </div>
                    <div className="modal-body">
                        <ChargeBackModalComponents
                            component={popUpComponent}
                            chargebackMetaData={chargebackMetaData}
                            onClose={() => setPopUpComponent(null)}
                            onSubmit={handleComponentSubmit}
                            subChargebackDetails={selectedSubChargeback}
                            transactionData={transactionData}
                            chargebackAgentAction={chargebackAgentAction}
                            currentChargebackStatus={
                                chargebackMetaData?.currentChargebackStatus
                            }
                        />
                    </div>
                </Modal>

                <AlertModal
                    modalIsOpen={fullyAccpetConfirm}
                    closeModal={() => setFullyAccpetConfirm(false)}
                    primaryButtonText="Yes, Accept"
                    secondaryButtonText="CANCEL"
                    showActions={true}
                    onSuccessModal={onFullyAcceptConfirm}
                    headerText={`Are you sure?`}
                    message={`Are you sure you want to accept chargeback?`}
                />
            </div>
        </div>
    );
};

// PropType validation for Chargeback component
ChargebackDetails.propTypes = {
    actions: PropTypes.object,
    chargebackReduxData: PropTypes.object,
    auth: PropTypes.object,
};

const mapStateToProps = ({ auth, chargebackData }) => ({
    auth,
    chargebackReduxData: chargebackData,
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchChargeBackDetailsRequest,
            chargeBackAgentActionRequest,
            chargeBackMerchantActionRequest,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChargebackDetails);
